import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useRecordContext } from "react-admin";
import config from "../config/config";
import logoWhite from "../assets/logo-white.png";

const usePreviewUrl = (thumbnailUrl, thumbnailFile) => {
  const [previewUrl, setPreviewUrl] = useState(thumbnailUrl || "");

  useEffect(() => {
    if (thumbnailFile && typeof URL !== "undefined") {
      const file = thumbnailFile.rawFile || thumbnailFile;
      if (file && typeof file === "object") {
        const url = URL.createObjectURL(file);
        setPreviewUrl(url);
        return () => URL.revokeObjectURL(url);
      }
    }
    setPreviewUrl(thumbnailUrl || "");
    return undefined;
  }, [thumbnailUrl, thumbnailFile]);

  return previewUrl;
};

const MediaThumbnail = ({ name, thumbnailUrl, thumbnailFile, scale = 1 }) => {
  const thumbCfg = config?.media_thumbnail || {};
  const width = Math.max(
    48,
    Math.round(Number(thumbCfg.width || 320) * Number(scale || 1)),
  );
  const height = Math.max(
    27,
    Math.round(Number(thumbCfg.height || 180) * Number(scale || 1)),
  );
  const previewUrl = usePreviewUrl(thumbnailUrl, thumbnailFile);

  if (previewUrl) {
    return (
      <Box
        component="img"
        src={previewUrl}
        alt={`Thumbnail ${name || ""}`}
        sx={{
          width: `${width}px`,
          height: `${height}px`,
          borderRadius: "8px",
          border: "1px solid rgba(0,0,0,0.2)",
          objectFit: "cover",
          objectPosition: "center",
          display: "block",
          background: "#f7f7f7",
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: `${width}px`,
        height: `${height}px`,
        borderRadius: "8px",
        border: "1px solid rgba(0,0,0,0.2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "primary.main",
      }}
    >
      <Box
        component="img"
        src={logoWhite}
        alt="ItaSat"
        sx={{
          width: "62%",
          maxWidth: `${Math.max(42, Math.round(width * 0.62))}px`,
          objectFit: "contain",
          opacity: 0.95,
          display: "block",
        }}
      />
    </Box>
  );
};

export const MediaThumbnailField = ({ scale = 1 }) => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <MediaThumbnail
      name={record.name}
      thumbnailUrl={record.thumbnail_url}
      scale={scale}
    />
  );
};

export const MediaThumbnailPreview = ({
  name,
  thumbnailUrl,
  thumbnailFile,
  scale = 1,
}) => (
  <MediaThumbnail
    name={name}
    thumbnailUrl={thumbnailUrl}
    thumbnailFile={thumbnailFile}
    scale={scale}
  />
);

export default MediaThumbnail;
